import type { ApAgentRun } from "./agent";
import type { ApInvoice } from "./documents";
import type { ApActionType } from "./statuses";

export interface ApPage<T> {
  items: T[];
  has_more: boolean;
  next_page: number | null;
}

export type ApReviewQueueInvoice = Omit<
  ApInvoice,
  "attachment" | "invoice_items" | "system_messages"
>;

export interface ApReviewQueueItem extends ApReviewQueueInvoice {
  last_completed_agent_run: ApAgentRun;
}

export interface ApAutomatedRunItem extends ApReviewQueueInvoice {
  automated_agent_run: ApAgentRun;
}

export interface ApInvoiceListReturnContext {
  businessId: string;
  listPath: string;
}

export type ApDayField = "added" | "reviewed";

export interface ApDayRange {
  from: string;
  to: string;
}

export const AP_UNASSIGNED = "none";

export interface ApReviewQueueFilters {
  actionTypes: ApActionType[];
  assigneeIds: string[];
  vendorIds?: string[];
  search?: string;
}

export interface ApReviewQueueVendor {
  id: string;
  name: string;
}
